<script>
    import Icon from '../icons/Icon.svelte';

    export let teamMembers = [];
    export let isLoadingTeam = false;
    export let onOpenMemberModal = () => {};
    export let onDeleteMember = () => {};

    let showPins = false;
</script>

<div class="tab-pane">
    <section class="settings-card">
        <div class="card-header team-header">
            <div>
                <div class="card-title-group">
                    <Icon name="users" size={18} />
                    <h4>Equipe, Garçons & Operadores do Salão</h4>
                </div>
                <span class="card-subtitle">Cadastre os garçons e operadores de caixa que utilizam PIN de 4 dígitos para comandas e atendimento.</span>
            </div>
            <div class="header-actions">
                <button type="button" class="btn-toggle-pin" on:click={() => showPins = !showPins}>
                    <Icon name={showPins ? 'eye-off' : 'eye'} size={14} />
                    <span>{showPins ? 'Ocultar PINs' : 'Mostrar PINs'}</span>
                </button>
                <button type="button" class="btn-add-member" on:click={() => onOpenMemberModal(null)}>
                    <Icon name="plus" size={14} />
                    <span>+ Novo Operador</span>
                </button>
            </div>
        </div>

        {#if isLoadingTeam}
            <div class="loading-state">
                <Icon name="refresh" size={16} />
                <span>Carregando membros da equipe...</span>
            </div>
        {:else if teamMembers.length === 0}
            <div class="empty-state">
                <Icon name="users" size={28} />
                <p>Nenhum operador adicional cadastrado. Apenas o proprietário tem acesso ao sistema no momento.</p>
            </div>
        {:else}
            <div class="team-grid">
                {#each teamMembers as member}
                    <div class="member-card {member.role === 'owner' ? 'owner-card' : ''}">
                        <div class="member-avatar">
                            <Icon name={member.role === 'owner' ? 'award' : member.role === 'waiter' ? 'user' : 'credit-card'} size={20} />
                        </div>
                        <div class="member-info">
                            <div class="member-title-row">
                                <span class="member-name">{member.name}</span>
                                <span class="role-pill {member.role}">
                                    {member.role === 'owner' ? 'Proprietário' : member.role === 'waiter' ? 'Garçom' : 'Caixa / Atendente'}
                                </span>
                            </div>
                            <span class="member-email">{member.email || 'Sem e-mail cadastrado'}</span>
                            <div class="pin-display">
                                <span class="pin-label">PIN de Acesso:</span>
                                {#if showPins}
                                    <span class="pin-val">{member.pin || 'Sem PIN'}</span>
                                {:else}
                                    <span class="pin-hidden">••••</span>
                                {/if}
                            </div>
                        </div>

                        {#if member.role !== 'owner'}
                            <div class="member-actions">
                                <button
                                    type="button"
                                    class="btn-member-action"
                                    title="Editar operador"
                                    on:click={() => onOpenMemberModal(member)}
                                >
                                    <Icon name="edit" size={13} />
                                </button>
                                <button
                                    type="button"
                                    class="btn-member-action del"
                                    title="Excluir operador"
                                    on:click={() => onDeleteMember(member)}
                                >
                                    <Icon name="trash" size={13} />
                                </button>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        {/if}
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .settings-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 22px 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .card-header {
        margin-bottom: 16px;
    }

    .team-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0F172A;
    }

    .card-title-group h4 {
        font-size: 0.98rem;
        font-weight: 700;
        margin: 0;
        color: #0F172A;
    }

    .card-subtitle {
        font-size: 0.82rem;
        color: #64748B;
        display: block;
        margin-top: 4px;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .btn-toggle-pin {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 7px 12px;
        border-radius: 6px;
        font-size: 0.78rem;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
    }

    .btn-toggle-pin:hover {
        background: #F8FAFC;
        border-color: #94A3B8;
        color: #0F172A;
    }

    .btn-add-member {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #fff;
        padding: 7px 14px;
        border-radius: 6px;
        font-size: 0.8rem;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.2);
        transition: all 0.2s;
    }

    .btn-add-member:hover {
        background: #EA580C;
    }

    .loading-state, .empty-state {
        text-align: center;
        padding: 30px;
        color: #64748B;
    }

    .empty-state p {
        font-size: 0.82rem;
        margin: 8px 0 0 0;
        color: #64748B;
    }

    .team-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 12px;
    }

    .member-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 14px;
        display: flex;
        align-items: center;
        gap: 12px;
        position: relative;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
        transition: all 0.2s ease;
    }

    .member-card:hover {
        border-color: #CBD5E1;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
    }

    .member-card.owner-card {
        border-color: #FED7AA;
        background: #FFF7ED;
    }

    .member-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #F1F5F9;
        color: #64748B;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .member-card.owner-card .member-avatar {
        background: #FFEDD5;
        color: #EA580C;
    }

    .member-info {
        flex: 1;
        overflow: hidden;
    }

    .member-title-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 2px;
    }

    .member-name {
        font-size: 0.88rem;
        font-weight: 700;
        color: #0F172A;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .role-pill {
        font-size: 0.65rem;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 4px;
        text-transform: uppercase;
    }

    .role-pill.owner {
        background: #FFEDD5;
        color: #C2410C;
        border: 1px solid #FED7AA;
    }

    .role-pill.waiter {
        background: #EFF6FF;
        color: #1D4ED8;
        border: 1px solid #BFDBFE;
    }

    .role-pill.cashier {
        background: #DCFCE7;
        color: #15803D;
        border: 1px solid #BBF7D0;
    }

    .member-email {
        font-size: 0.74rem;
        color: #64748B;
        display: block;
        margin-bottom: 4px;
    }

    .pin-display {
        font-size: 0.74rem;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .pin-label {
        color: #64748B;
    }

    .pin-val {
        font-family: monospace;
        font-weight: 700;
        color: #B45309;
    }

    .pin-hidden {
        color: #94A3B8;
        letter-spacing: 2px;
    }

    .member-actions {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .btn-member-action {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        color: #64748B;
        padding: 5px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }

    .btn-member-action:hover {
        background: #F1F5F9;
        color: #0F172A;
    }

    .btn-member-action.del:hover {
        background: #FEF2F2;
        border-color: #FCA5A5;
        color: #DC2626;
    }
</style>
